// eslint-disable-next-line no-unused-vars
import React from 'react';
import { oneOf } from 'prop-types';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';

const Badge = styled.span`
  background: ${ props => (props.expired ? '#fcf3f1' : '#edf8f5') };
  border: 1px solid ${ props => (props.expired ? '#e49a94' : '#73b5a5') };
  border-radius: 999px;
  color: ${ props => (props.expired ? props.theme.colors.red : '#236658') };
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 600;
  padding: 0.2rem 0.5rem;
  white-space: nowrap;
`;

const STATUS_KEYS = {
  expired: 'offers.expiredStatus',
  valid: 'offers.validStatus',
  saved: 'offers.savedStatus',
  private: 'offers.privateStatus'
};

const OfferStatusBadge = ({ status }) => {
  const { t } = useTranslation();
  const expired = status === 'expired';

  return (
    <Badge expired={ expired }>
      { t(STATUS_KEYS[status] || 'offers.privateStatus') }
    </Badge>
  );
};

OfferStatusBadge.propTypes = {
  status: oneOf(['expired', 'valid', 'saved', 'private'])
};

export default OfferStatusBadge;
